import PersonalExercise from './PersonalExercise';

export default PersonalExercise;
